import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerEmployabilityCharter: [
    'acadCareer',
    'campus',
    'charterDesc',
    'charterType',
    'companyName',
    'duration',
    'periodId',
    'position',
    'representative',
    'studentType',
    'periodRelativeCP'
  ],
  // Reducer
  registerEmployabilityCharterClear: null,
  registerEmployabilityCharterRequest: null,
  registerEmployabilityCharterSuccess: null,
  registerEmployabilityCharterFailure: ['error']
});

export { Creators, Types };
